import type { Availability, NonAvailability } from "./availability-event.types";
import type { DeviationType } from "../utils/compute-deviation";

export type SchedulerEventKind =
	| "booking"
	| "blocked"
	| "available"
	| "not-available"
	| "not-allowed";

export const SchedulerContentView = {
	TIMELINE: "timeline",
	MAP: "map",
} as const;
export type SchedulerContentView =
	(typeof SchedulerContentView)[keyof typeof SchedulerContentView];

export const SchedulerViewMode = {
	DAY: "day",
	WEEK: "week",
	MONTH: "month",
} as const;

export type SchedulerViewMode =
	(typeof SchedulerViewMode)[keyof typeof SchedulerViewMode];

export interface SchedulerPeriod {
	start: Date;
	end: Date;
}

export interface SchedulerEvent {
	kind: SchedulerEventKind;
	id: string;
	vehicleId: string;
	nonAvailability?: NonAvailability;
	availability?: Availability;
	start: Date;
	end: Date;
	isOverdue: boolean;
	deviationType?: DeviationType;
	plannedEnd?: Date;
	lane: number;
	totalLanes: number;
	/**
	 * Paint order within a vehicle row. Ground events (availability + blocked) are
	 * ordered by containment (outer below, nested on top); foreground events
	 * (bookings) always sit above every ground event.
	 */
	zIndex: number;
}

export interface VehicleSchedulerData {
	nonAvailabilities: Array<NonAvailability>;
	availabilities: Array<Availability>;
}

export interface EventPosition {
	leftPercent: number;
	widthPercent: number;
}
